import React from 'react'
import styled, { css } from 'styled-components'
import { media } from 'src/styles/styled-components'
import PropTypes from 'prop-types'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArTextWithImageHeading from 'src/components/typography/ArTextWithImageHeading'
import ArTextWithImageDescription from 'src/components/typography/ArTextWithImageDescription'
import { generateScProps, deviceInfoProvider, generateJSX } from 'src/utils'
import ArBaseButton from 'src/components/ArBaseButton/ArBaseButton'

const StyledWrapper = styled.section`
  margin-bottom: ${ p => p.scComponentMargins.bottom[0] };
  margin-top: ${ p => p.scComponentMargins.top[0] };
  overflow: hidden;

  ${ media.tablet`
    margin-bottom: ${ p => p.scComponentMargins.bottom[1] };
    margin-top: ${ p => p.scComponentMargins.top[1] };
  ` }

  ${ media.desktop`
    margin-bottom: ${ p => p.scComponentMargins.bottom[2] };
    margin-top: ${ p => p.scComponentMargins.top[2] };
  ` }
`

const StyledContainer = styled(ArBaseContainer)`
  ${ media.tablet`
    display: flex;
    align-items: ${ p => p.scFlexAlign || 'center' };
    justify-content: space-between;
    flex-direction: ${ p => p.scImageToRight && 'row-reverse' };
  ` }
`

const StyledImage = styled(ArBaseImage)`
  margin-left: ${ p => p.scImageMargins.left[0] };
  margin-bottom: ${ p => p.scImageMargins.bottom[0] };
  margin-right: ${ p => p.scImageMargins.right[0] };

  ${ media.tablet`
    margin-left: ${ p => p.scImageMargins.left[1] };
    margin-bottom: ${ p => p.scImageMargins.bottom[1] };
    margin-right: ${ p => p.scImageMargins.right[1] };
    flex-shrink: 100;
  ` }

  ${ media.desktop`
    margin-left: ${ p => p.scImageMargins.left[2] };
    margin-bottom: ${ p => p.scImageMargins.bottom[2] };
    margin-right: ${ p => p.scImageMargins.right[2] };
  ` }
`

const StyledTextWrapper = styled.div`
  text-align: center;

  ${ media.tablet`
    text-align: left;
    margin-right: ${ p =>
    p.scImageToRight ? (p.scGap[1] / p.theme.gridWidth) * 100 + '%' : 0 };
    margin-left: ${ p =>
    !p.scImageToRight ? (p.scGap[1] / p.theme.gridWidth) * 100 + '%' : 0 };
    width: 45%;
  ` }

  ${ media.desktop`
    margin-right: ${ p =>
    p.scImageToRight ? (p.scGap[2] / p.theme.gridWidth) * 100 + '%' : 0 };
      margin-left: ${ p =>
    !p.scImageToRight ? (p.scGap[2] / p.theme.gridWidth) * 100 + '%' : 0 };
    width: 40%; /* 500px */
  ` }
`

const StyledTitle = styled(ArTextWithImageHeading)`
  margin-bottom: 20px;
  max-width: ${ p => p.scTitleMaxWidth && p.scTitleMaxWidth[0] };

  ${ media.tablet`
    margin-bottom: 30px;
    max-width: ${ p => p.scTitleMaxWidth && p.scTitleMaxWidth[1] };
  ` }

  ${ media.desktop`
    max-width: ${ p => p.scTitleMaxWidth && p.scTitleMaxWidth[2] };
  ` }
`

const StyledDescription = styled(ArTextWithImageDescription)``

class ArTextWithImage extends React.Component {
  static propTypes = {
    images: PropTypes.array, // [ 'mobile', 'tablet', 'desktop' ]
    title: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    scImageToRight: PropTypes.bool,
    scImageMargins: PropTypes.shape({
      right: PropTypes.arrayOf(PropTypes.string), // [ 'mobile', 'tablet', 'desktop' ]
      bottom: PropTypes.arrayOf(PropTypes.string),
      left: PropTypes.arrayOf(PropTypes.string),
    }),
    scComponentMargins: PropTypes.shape({
      top: PropTypes.arrayOf(PropTypes.string),
      bottom: PropTypes.arrayOf(PropTypes.string),
    }),
    scGap: PropTypes.arrayOf(PropTypes.number), // ['mobile', 'tablet', 'desktop']
    scFlexAlign: PropTypes.string,
    scTitleMaxWidth: PropTypes.arrayOf(PropTypes.string),
  };

  get deviceImage () {
    if (this.props.device.isDesktop) return this.props.images[2]
    else if (this.props.device.isTablet) return this.props.images[1]
    else if (this.props.device.isMobile) return this.props.images[0]
    else return {}
  }

  render () {
    const { title, description } = this.props
    const scProps = generateScProps(this.props)
    const image = this.deviceImage

    return (
      <StyledWrapper {...scProps}>
        <StyledContainer {...scProps}>
          <StyledImage src={image.url} alt={image.alt} {...scProps} />
          <StyledTextWrapper {...scProps}>
            <StyledTitle {...scProps}>{title}</StyledTitle>
            <StyledDescription>{generateJSX(description)}</StyledDescription>
          </StyledTextWrapper>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default deviceInfoProvider(ArTextWithImage)
